import { Component } from '@mycolorway/tao';
import { throttle } from 'next/javascripts/modules/utils';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/sticky-panel.scss';

Component('tr-sticky-panel', {
  mixins: [eventListenerMixin],

  properties: {
    isSticky: {
      type: Boolean,
      default: false,
      observer: 'setContentSize',
    },

    limiter: String,

    limiterOffset: {
      type: Number,
      default: 100,
    },

    scrollContainer: String,
  },

  connected() {
    this.placeholder = this.querySelector('.placeholder');
    this.content = this.querySelector('.content');

    if (this.scrollContainer) {
      this.scrollContainerElement = closest(this, this.scrollContainer);
    }

    if (this.limiter) {
      this.limiterElement = document.querySelector(this.limiter);
    }

    this.checkIfShouldBeSticky = throttle(this.checkSticky.bind(this), 100);
    this.listenTo(this.scrollContainerElement || window, {
      scroll: this.checkIfShouldBeSticky,
    });
    this.listenTo(window, 'resize', this.checkIfShouldBeSticky);
  },

  disconnected() {
    this.stopListening();
  },

  checkSticky() {
    if (!this.limiterElement) {
      this.isStickyTop = false;
      this.isStickyBottom = false;
    } else {
      const viewportRect = this.getViewportRect();
      const panelRect = this.getBoundingClientRect();
      const limiterRect = this.limiterElement.getBoundingClientRect();

      this.isStickyTop = panelRect.top < viewportRect.top
        && limiterRect.bottom > panelRect.height + viewportRect.top + this.limiterOffset;
      this.isStickyBottom = panelRect.bottom > viewportRect.bottom
        && limiterRect.top < viewportRect.bottom - this.limiterOffset;
    }

    this.isSticky = this.isStickyTop || this.isStickyBottom;
  },

  targetIsBelow(target) {
    const rect = this.content.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const viewportRect = this.getViewportRect();

    if (this.isStickyBottom) {
      return targetRect.bottom + rect.height > viewportRect.bottom;
    }

    return targetRect.top > rect.height + viewportRect.top;
  },

  setContentSize() {
    const { height } = this.content.getBoundingClientRect();
    this.placeholder.style.height = this.isSticky ? `${height}px` : '';

    const { width } = this.placeholder.getBoundingClientRect();
    const contentStyle = this.content.style;
    contentStyle.width = this.isSticky ? `${width}px` : 'auto';
    contentStyle.top = this.isStickyTop ? '0px' : 'auto';
    contentStyle.bottom = this.isStickyBottom ? '0px' : 'auto';
  },

  getViewportRect() {
    if (this.scrollContainerElement) {
      return this.scrollContainerElement.getBoundingClientRect();
    }

    const { clientHeight: viewportHeight } = document.documentElement;
    return {
      top: 0,
      bottom: viewportHeight,
      height: viewportHeight,
    };
  },
});
